export default __webpack_public_path__ + "static/media/santa-maria-9.31a1c299.jpg";